import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
export function LivePlayer({ cameraId, autoplay = true, muted = true, controls = true, className, }) {
    const videoRef = useRef(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const video = videoRef.current;
        if (!video)
            return;
        const src = `/api/cameras/${encodeURIComponent(cameraId)}/hls/index.m3u8`;
        let hls = null;
        let cancelled = false;
        const setAndPlay = async () => {
            if (cancelled)
                return;
            if (autoplay) {
                try {
                    await video.play();
                }
                catch {
                    // Browser autoplay policy may block until user gesture.
                }
            }
        };
        setError(null);
        if (Hls.isSupported()) {
            hls = new Hls({
                liveDurationInfinity: true,
                enableWorker: true,
            });
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                hls?.loadSource(src);
            });
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                void setAndPlay();
            });
            hls.on(Hls.Events.ERROR, (_event, data) => {
                if (data?.fatal) {
                    setError(data.details || 'HLS playback error');
                    hls?.destroy();
                    hls = null;
                }
            });
        }
        else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;
            void setAndPlay();
        }
        else {
            setError('HLS is not supported in this browser');
        }
        return () => {
            cancelled = true;
            if (hls) {
                hls.destroy();
            }
            if (video) {
                video.removeAttribute('src');
                video.load();
            }
        };
    }, [cameraId, autoplay]);
    if (error) {
        return (_jsxs("div", { className: "live-player-error", role: "status", children: ["Live stream unavailable: ", error] }));
    }
    return (_jsx("video", { ref: videoRef, className: className ?? 'live-player', controls: controls, muted: muted, autoPlay: autoplay, playsInline: true }));
}
